import React, { useState, useEffect } from 'react';
import { useGlobalPopup } from "../../contexts/GlobalPopupContext";
import { useTranslation } from "../../contexts/TranslationContext";
import api from '../../utils/api';

const HistoryFilter = ({
  filters,
  onFilterChange,
  onSearch,
  onReset,
  onRefreshFilters,
  isLoading,
  isLoadingFilters
}) => {
  const { showPopup } = useGlobalPopup();
  const { language } = useTranslation();
  const [filterOptions, setFilterOptions] = useState({
    agencies: [],
    users: [],
    engineVersions: []
  });

  const [arrUsersByAgency, setArrUsersByAgency] = useState([]);

  const tokenRequestAPI = localStorage.getItem('FWToken');

  // Fetch filter options from API
  const fetchHistoryFilters = async () => {
    try {
      const requestBody = {
        fields: [
          "agency",
          "user",
          "engineversion"
        ]
      };

      const response = await api.post(
        `${global.config.api.domain}/fwiq-api/api/search1n/history/filters`,
        { Token: tokenRequestAPI, ...requestBody }
      );

      const result = response.data;

      if (result) {
        setFilterOptions({
          agencies: Array.isArray(result.Agencies) ? result.Agencies : [],
          users: Array.isArray(result.Users) ? result.Users : [],
          engineVersions: Array.isArray(result.EngineVersions) ? result.EngineVersions : []
        });

        console.log('History filters loaded successfully:', {
          agencies: result.Agencies?.length || 0,
          users: result.Users?.length || 0,
          engineVersions: result.EngineVersions?.length || 0
        });
      }
    } catch (error) {
      console.error('Error fetching history filters:', error);

      showPopup({
        type: 'warning',
        title: language.historyFilter?.filterLoadingWarning || 'Filter Loading Warning',
        content: language.historyFilter?.filterLoadingMessage || 'Failed to load filter options. You can still search with date ranges.',
        options: [{ text: language.historyFilter?.ok || 'OK', action: null, type: 'default' }],
        showCloseButton: true,
        backdrop: true
      });

      // Set empty arrays as fallback
      setFilterOptions({
        agencies: [],
        users: [],
        engineVersions: []
      });
    }
  };

  // Load filter options on component mount
  useEffect(() => {
    fetchHistoryFilters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // load users when agency changes
  useEffect(() => {
    if (!filters.agency) {
      setArrUsersByAgency(filterOptions.users);
      return;
    }

    if (filters.agency) {
      const filteredUsers = filterOptions.users.filter(user => user.ID.indexOf(`${filters.agency}-`) > -1);
      setArrUsersByAgency(filteredUsers);
    }
  }, [filters.agency, filterOptions.users]);

  // Handle filter change
  const handleFilterChange = (field, value) => {
    onFilterChange(field, value);
  };

  // Handle search
  const handleSearch = () => {

    // Check date range validity

    onSearch();
  };

  // Handle reset filters
  const handleResetFilters = () => {
    onReset();
  };

  // Handle refresh filters
  const handleRefreshFilters = () => {
    fetchHistoryFilters();
    if (onRefreshFilters) {
      onRefreshFilters();
    }
  };

  return (
    <>
      <div className="sidebar-header">
        <div className="filters-header">
          <i className="fa fa-filter"></i>
          <span>
            {language.historyFilter?.filters || "Filters"}
          </span>
        </div>
        {isLoadingFilters && (
          <i className="fa fa-spinner fa-spin filter-loading-icon"></i>
        )}

        <div className="filter-actions">
          <button
            className="btn btn-default"
            onClick={handleResetFilters}
          >
            <i className="fa fa-refresh"></i> {language.historyFilter?.resetAll || "Reset All"}
          </button>
        </div>

      </div>

      <div className="sidebar-filters">

        {/* Record Count Filter - Commented out as in original */}
        {/* <div className="filter-section">
          <h4>Record Limit</h4>
          <div className="a-filter">
            <label>Last Records:</label>
            <select
              value={filters.recordCount}
              onChange={(e) => handleFilterChange('recordCount', e.target.value)}
              disabled={filters.fromDate || filters.toDate}
            >
              <option value={50}>Last 50</option>
              <option value={100}>Last 100</option>
              <option value={500}>Last 500</option>
              <option value={1000}>Last 1000</option>
              <option value="">All</option>
            </select>
          </div>
        </div> */}

        {/* Advanced Filters */}
        <div className="filter-section">
          <div className="a-filter">
            <label>{language.historyFilter?.agency || "Agency:"}</label>
            <select
              value={filters.agency}
              onChange={(e) => handleFilterChange('agency', e.target.value)}
              disabled={isLoadingFilters}
            >
              <option value="">{language.historyFilter?.allAgencies || "All Agencies"}</option>
              {filterOptions.agencies.map((agency) => (
                <option key={agency.ID || agency.Key} value={agency.ID || agency.Key}>
                  {agency.Value || agency.name}
                </option>
              ))}
            </select>
          </div>

          <div className="a-filter">
            <label>{language.historyFilter?.user || "User:"}</label>
            <select
              value={filters.user}
              onChange={(e) => handleFilterChange('user', e.target.value)}
              disabled={isLoadingFilters}
            >
              <option value="">{language.historyFilter?.allUsers || "All Users"}</option>
              {arrUsersByAgency.map((user) => (
                <option key={user.ID || user.Key} value={user.ID || user.Key}>
                  {user.Value || user.name}
                </option>
              ))}
            </select>
          </div>

          <div className="a-filter" style={{ display: 'none' }}>
            <label>{language.historyFilter?.engineVersion || "Engine Version:"}</label>
            <select
              value={filters.engineVersion}
              onChange={(e) => handleFilterChange('engineVersion', e.target.value)}
              disabled={isLoadingFilters}
            >
              <option value="">{language.historyFilter?.allVersions || "All Versions"}</option>
              {filterOptions.engineVersions.map((version, index) => (
                <option key={index} value={version}>
                  {version}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Date Filters */}
        <div className="filter-section">

          <div className="a-filter">

            <label>{language.historyFilter?.fromDate || "From Date:"}</label>


            <input
              type="datetime-local"
              value={filters.fromDate}
              onChange={(e) => handleFilterChange('fromDate', e.target.value)}
            />

          </div>
          <div className="a-filter">
            <label>{language.historyFilter?.toDate || "To Date:"}</label>
            <input
              type="datetime-local"
              value={filters.toDate}
              onChange={(e) => handleFilterChange('toDate', e.target.value)}
            />
          </div>
        </div>

        {/* Filter Actions */}
        <div className="filter-actions">
          <button
            className="apply-filters-btn"
            onClick={handleSearch}
            disabled={isLoading}
          >
            <i className="fa fa-filter"></i> {language.buttons?.applyFilters || "Apply Filters"}
          </button>

        </div>
      </div>
    </>
  );
};

export default HistoryFilter;
